import React, { useEffect } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import TokenSection from './TokenSection';
import ProblemSection from './ProblemSection';
import ArchitectureSection from './ArchitectureSection';
import PaymentsSection from './PaymentsSection';
import ManagementSection from './ManagementSection';
import BuildSection from './BuildSection';
import Footer from './Footer';
import { Toaster } from '../ui/sonner';
import './LandingPage.css';

const LandingPage = () => {
  useEffect(() => {
    const sections = Array.from(document.querySelectorAll('.landing-page > section'));
    if (!sections.length) return;

    sections.forEach((el, i) => {
      // Keep the first (hero) section immediately visible; reveal the rest on scroll
      if (i === 0) return;
      el.classList.add('scroll-reveal');
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.slice(1).forEach((el) => observer.observe(el));

    // Safety fallback: reveal everything after 3s in case observer never fires
    const fallback = setTimeout(() => {
      sections.forEach((el) => el.classList.add('is-visible'));
    }, 3000);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, []);

  return (
    <div className="landing-page">
      {/* Header */}
      <Header />
      
      <Toaster theme="dark" position="bottom-center" offset={80} richColors />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Token Section */}
      <TokenSection />
      
      {/* Problems Section */}
      <ProblemSection />
      
      {/* Architecture Section - Zyber Secure */}
      <ArchitectureSection />
      
      {/* Payments Section */}
      <PaymentsSection />
      
      {/* Management Section */}
      <ManagementSection />
      
      {/* Build Section */}
      <BuildSection />
      
      {/* Footer */}
      <Footer />
      
      {/* Bottom Announcement Bar */}
      <div className="bottom-announcement" data-testid="bottom-announcement">
        <span className="announcement-brand">ZyberSEC</span>
        <span className="announcement-dot">•</span>
        <span className="announcement-text">Private, secure access to AI</span>
      </div>
    </div>
  );
};

export default LandingPage;
